import React, { Component } from 'react'
import Cards from './Cards'

export default class Services extends Component {
    render() {
        return (
            <div className="content container services">
                <h2>Services</h2>
                <div className="row">
                    <div className="col-md-6">
                        <Cards headings="Static Website" image="https://cdn.pixabay.com/photo/2018/06/18/17/55/web-3482970_960_720.png" />
                    </div>
                    <div className="col-md-6">
                        <Cards headings="Dynamic Website" image="https://www.seobility.net/en/wiki/images/0/04/Frontend-vs-Backend.png" />
                    </div>
                </div> 
            </div>
        )
    }
}
